'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var loadYouTubeIframeApi = {exports: {}};

exports.loadYouTubeIframeApi = loadYouTubeIframeApi;
